import { defineComponent as _defineComponent } from 'vue'
import X from '@/components/svg/x-circle.svg?inline';

export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryTag',
  setup(__props) {


return { __sfc: true,X }
}

})